"use client";

import { useEffect } from "react";
import { TreatmentName } from "@leafly-com/split-next/dist/custom-types";
import { getMinutes } from "date-fns";

import {
  EVENT_DEBOUNCE_DURATION,
  useSplitGoogleEventPublisher,
} from "@/hooks/useSplitGoogleEventPublisher";

/**
 * Emits Google Analytics events for Split treatments that are requested
 * during server-side rendering. Treatments that are seen multiple times
 * are emitted roughly once for the lifecycle of the session, including
 * client-side navigation.
 */
const SplitServerEvents: React.FC<{
  treatments: { [key in TreatmentName]?: string };
}> = ({ treatments }) => {
  const publishEvent = useSplitGoogleEventPublisher();

  useEffect(() => {
    Object.entries(treatments).forEach(([name, treatment]) => {
      if (treatment) {
        publishEvent(name, treatment);
      }
    });
  }, [
    JSON.stringify(treatments),
    Math.round(getMinutes(new Date()) / EVENT_DEBOUNCE_DURATION),
  ]);

  return null;
};

export default SplitServerEvents;
